module.exports = __webpack_public_path__ + "img/toilet_paper_being_thrown.719588fe.jpg";